export default __webpack_public_path__ + "static/case-study-desktop-18bc5a71d9929908c4f839be10e9f5ad.png";